import { memo } from 'react';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { hasScope } from 'app/scopes/scopes';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';

const AdminsOptions = memo(({ authEmail = '', admin, onDelete, onUpdate, subjectScopes }) => {
  return (
    <div className="flex w-full flex-wrap flex-row justify-around items-center">
      <Button
        className="my-3 mr-3"
        onClick={() => onUpdate(admin.id)}
        size="small"
        variant="contained"
        color="info"
        style={{ width: 'auto' }}
        startIcon={<EditOutlinedIcon />}
        disabled={admin.email === authEmail || !hasScope(subjectScopes, 'Admins', 'update')}
      >
        Editar
      </Button>
      <Button
        className="my-3 ml-3"
        onClick={() => onDelete(admin.id, admin.name)}
        size="small"
        variant="contained"
        color="error"
        style={{ width: 'auto' }}
        startIcon={<PersonOffOutlinedIcon />}
        disabled={admin.email === authEmail || !hasScope(subjectScopes, 'Admins', 'delete')}
      >
        Eliminar
      </Button>
    </div>
  );
});

export default AdminsOptions;
